import React from 'react'
import { Col, Row, Card, Button, Form } from '@themesberg/react-bootstrap'
import { inject, observer } from 'mobx-react'
import Select from '../../ui/Dropdown'
import { default as ReactSelect } from 'react-select'
import { components } from 'react-select'
import makeAnimated from 'react-select/animated'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useRef, useEffect } from 'react'
import * as XLSX from 'xlsx';

const customStyles = {
	control: (base) => ({
		...base,
		background: '#e7e3f9',
		height: 44,
		minHeight: 44,
		minWidth: 100,
		width: 240,
		option: (styles, { data, isDisabled, isFocused, isSelected }) => {
			return {
				...styles,
				backgroundColor: '#c3b9f1',
			}
		},
	}),
	multiValue: (styles, { data }) => {
		return {
			...styles,
			backgroundColor: '#c3b9f1',
		}
	},
}
export default inject('providerPriceCompareStore')(
	observer(({ providerPriceCompareStore, procCategory, hideModifier, actionFunc, showAggMeasure, showExport, hideProcCategoty }) => {
	
		const downloadExcel = (data) => {
			const worksheet = XLSX.utils.json_to_sheet(data);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
			//let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
			//XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
			XLSX.writeFile(workbook, "DataSheet.xlsx");
		  };

		useEffect(() => {
			providerPriceCompareStore.setFilterData('region', null)

			providerPriceCompareStore.setFilterData('specialty', null)
			providerPriceCompareStore.setFilterData('level1Desc', null)
			
			providerPriceCompareStore.setFilterData('modifier', null)

			providerPriceCompareStore.setFilterData('feeScheduleType',null)
			providerPriceCompareStore.setFilterData('group',null)
			
			providerPriceCompareStore.setFilterData('placeOfService',null)
			providerPriceCompareStore.setFilterData('reportingEntityName',null)
			providerPriceCompareStore.setFilterData('billingCode',null)
			
			providerPriceCompareStore.proceduresCatList = procCategory.map(category => ({
				id: category,
				name: category,
				value: category
			}))
			
		}, [procCategory])

		return (
			<Card border="light" className="shadow-sm filterSection">
				<Card.Body>
					<h5>
						Filter{' '}
						{ showExport && (<span className="downloadBtn ">
							<svg
								width="20"
								height="20"
								viewBox="0 0 123 121"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clipPath="url(#clip0_4_39)">
									<path
										d="M84.58 47C85.2961 46.2624 86.1525 45.6755 87.0988 45.2737C88.0451 44.872 89.0621 44.6635 90.0902 44.6607C91.1182 44.6578 92.1364 44.8605 93.0849 45.257C94.0335 45.6534 94.8931 46.2355 95.6133 46.9691C96.3336 47.7026 96.8998 48.5728 97.2788 49.5285C97.6578 50.4841 97.8418 51.5059 97.82 52.5337C97.7983 53.5615 97.5712 54.5746 97.1522 55.5133C96.7332 56.4521 96.1306 57.2975 95.38 58L66.09 86.88C64.6464 88.2981 62.7036 89.0927 60.68 89.0927C58.6564 89.0927 56.7136 88.2981 55.27 86.88L26.4 58.37C24.9413 56.9365 24.1118 54.9823 24.094 52.9372C24.0762 50.8921 24.8715 48.9237 26.305 47.465C27.7385 46.0063 29.6927 45.1768 31.7378 45.159C33.7829 45.1412 35.7513 45.9365 37.21 47.37L53.1 63.12L53.26 7.65C53.3468 5.65118 54.2063 3.76414 55.6572 2.38657C57.1081 1.009 59.0371 0.248502 61.0378 0.265358C63.0384 0.282213 64.9544 1.0751 66.3818 2.47692C67.8093 3.87874 68.6369 5.78 68.69 7.78L68.54 62.78L84.58 47ZM0 113.48L0.1 83.3C0.0733066 82.2639 0.255513 81.233 0.635757 80.2689C1.016 79.3047 1.58649 78.427 2.31323 77.688C3.03996 76.9491 3.90804 76.364 4.86573 75.9677C5.82341 75.5715 6.85109 75.3721 7.88748 75.3815C8.92387 75.3909 9.94776 75.6089 10.8981 76.0225C11.8484 76.4361 12.7058 77.0368 13.419 77.7888C14.1322 78.5408 14.6866 79.4288 15.0493 80.3997C15.412 81.3706 15.5755 82.4046 15.53 83.44L15.46 105.44C46.1267 105.5 76.7633 105.5 107.37 105.44L107.44 83.32C107.459 81.2725 108.29 79.3163 109.751 77.8816C111.212 76.447 113.183 75.6514 115.23 75.67C117.277 75.6886 119.234 76.5197 120.668 77.9806C122.103 79.4415 122.899 81.4125 122.88 83.46L122.78 113.46H122.69C122.6 115.432 121.758 117.294 120.337 118.663C118.916 120.032 117.023 120.804 115.05 120.82C79.23 120.887 43.4367 120.887 7.67 120.82C5.69389 120.814 3.79555 120.049 2.36785 118.683C0.940148 117.317 0.0923821 115.454 0 113.48H0Z"
										fill="#B54491"
									/>
								</g>
								<defs>
									<clipPath id="clip0_4_39">
										<rect width="122.88" height="120.89" fill="white" />
									</clipPath>
								</defs>
							</svg>
							<span className="ml-5" onClick={()=>downloadExcel(providerPriceCompareStore.priceDiffAvgList?.data)}>Download</span>
						</span>)}
					</h5>
					<Row>
						<Col className=" col-auto col-auto">
							<div
								className="mb-3"
								title={
									providerPriceCompareStore.selectedFilterData.region?.name
								}
							>
								<label className="form-label">
									Region<span className="text-danger">*</span>
								</label>
								<Select
									className={`select-menu ${
										providerPriceCompareStore.selectedFilterData.region != ''
											? ''
											: 'invalidFilter'
									}`}
									value={providerPriceCompareStore.selectedFilterData.region}
									options={providerPriceCompareStore.regionList}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData('region', e)

										providerPriceCompareStore.setFilterData('specialty', null)
										
										providerPriceCompareStore.setFilterData('level1Desc', null)
										
										providerPriceCompareStore.setFilterData('modifier', null)
										providerPriceCompareStore.setFilterData('feeScheduleType',null)
										providerPriceCompareStore.setFilterData('group',null)			
										providerPriceCompareStore.setFilterData('placeOfService',null)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
										
										providerPriceCompareStore.getLevel1DescList();
										
										//providerPriceCompareStore.getSpecialtyList()
										// providerPriceCompareStore.getProceduresCatList()
										//providerPriceCompareStore.getProceduresCatList()
										providerPriceCompareStore.resetPayerPriceCompList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
								/>
							</div>
						</Col>
						<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">
									Level 1 Description<span className="text-danger">*</span>
								</label>
								<Select
									className={`select-menu ${
										providerPriceCompareStore.selectedFilterData.level1Desc !=
										''
											? ''
											: 'invalidFilter'
									}`}
									aria-label="Default select example"
									value={
										providerPriceCompareStore.selectedFilterData.level1Desc
									}
									isMulti={false}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData('level1Desc', e)

										providerPriceCompareStore.setFilterData('specialty', null)
										providerPriceCompareStore.setFilterData('modifier', null)
										providerPriceCompareStore.setFilterData('feeScheduleType',null)
										providerPriceCompareStore.setFilterData('group',null)			
										providerPriceCompareStore.setFilterData('placeOfService',null)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
										
										providerPriceCompareStore.getFeeScheduleTypeList()
										//providerPriceCompareStore.getmodifierList()
										//providerPriceCompareStore.getProcedureNameList()
										providerPriceCompareStore.resetPayerPriceCompList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									options={providerPriceCompareStore.level1DescList}
								/>
								{/* {providerPriceCompareStore.selectedFilterData.level1Desc == '' && (
									<div className="invalid-input">
										Please select Level 1 Description
									</div>
								)} */}
							</div>
						</Col>
						<Col className=" col-auto col-auto">
							<div className="mb-3">
							<label className="form-label">Fee Schedule Type <span className='text-danger'>*</span></label>
								<div className="d-flex align-items-center h45 NPI-select">
									<Select
										className={`select-menu`}
										value={providerPriceCompareStore.selectedFilterData.feeScheduleType}
										onChange={(e, data) => {
											
											
												providerPriceCompareStore.setFilterData('feeScheduleType', e)
												providerPriceCompareStore.setFilterData('specialty', null)										
										providerPriceCompareStore.setFilterData('modifier', null)																				
										providerPriceCompareStore.setFilterData('group',null)			
										providerPriceCompareStore.setFilterData('placeOfService',null)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
											providerPriceCompareStore.resetPayerPriceCompList()
										}}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
										options={
											providerPriceCompareStore.feeScheduleTypeList?.length
												?providerPriceCompareStore.feeScheduleTypeList 
												: []
										}
										allowSelectAll={true}
										
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
										
									/>
									<button
										type="button"
										disabled={
											providerPriceCompareStore.selectedFilterData.feeScheduleType == '' ||
											providerPriceCompareStore.selectedFilterData.feeScheduleType == undefined ||
											providerPriceCompareStore.selectedFilterData.feeScheduleType == null ||
											!providerPriceCompareStore.selectedFilterData.feeScheduleType?.length
										}
										className="NPI-submit btn btn-primary btn-sm"
										onClick={()=>{											
										providerPriceCompareStore.setFilterData('specialty', null)										
										providerPriceCompareStore.setFilterData('modifier', null)																				
										providerPriceCompareStore.setFilterData('group',null)			
										providerPriceCompareStore.setFilterData('placeOfService',null)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
										
										providerPriceCompareStore.getSpecialtyList()
										providerPriceCompareStore.resetPayerPriceCompList()
										}}
									>
										<FontAwesomeIcon
											icon={faArrowRight}
											className="dropdown-arrow"
											size="lg"
										/>
									</button>
								</div>
							</div>
						</Col>
						<Col className=" col-auto col-auto">
							<div className="mb-3">
								<label className="form-label">Specialty <span className='text-danger'>*</span></label>
								<div className="d-flex align-items-center h45 NPI-select">
								<Select
										className={`select-menu`}
										value={providerPriceCompareStore.selectedFilterData.specialty}
										onChange={(e, data) => {
											
												providerPriceCompareStore.setFilterData('specialty', e)
												providerPriceCompareStore.setFilterData('group',null)			
												providerPriceCompareStore.setFilterData('placeOfService',null)
												providerPriceCompareStore.setFilterData('reportingEntityName',null)
												providerPriceCompareStore.setFilterData('billingCode',null)
												providerPriceCompareStore.setFilterData('modifier', null)
											providerPriceCompareStore.resetPayerPriceCompList()
										}}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
										options={
											providerPriceCompareStore.specialtyList?.length
												? providerPriceCompareStore.specialtyList 
												: []
										}
										allowSelectAll={true}
									
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
									
									/>
									<button
										type="button"
										disabled={
											providerPriceCompareStore.selectedFilterData.specialty == '' ||
											providerPriceCompareStore.selectedFilterData.specialty == undefined ||
											providerPriceCompareStore.selectedFilterData.specialty == null ||
											!providerPriceCompareStore.selectedFilterData.specialty?.length
										}
										className="NPI-submit btn btn-primary btn-sm"
										onClick={()=>{										
																			
																													
										providerPriceCompareStore.setFilterData('group',null)			
										providerPriceCompareStore.setFilterData('placeOfService',null)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
										providerPriceCompareStore.setFilterData('modifier', null)
									
										providerPriceCompareStore.getGroupList()
										providerPriceCompareStore.resetPayerPriceCompList()
										}}
									>
										<FontAwesomeIcon
											icon={faArrowRight}
											className="dropdown-arrow"
											size="lg"
										/>
									</button>
									{/* <Select
										className={`select-menu ${
											providerPriceCompareStore.selectedFilterData.specialty !=
											''
												? ''
												: 'invalidFilter'
										}`}
										value={
											providerPriceCompareStore.selectedFilterData.specialty
										}
										options={providerPriceCompareStore.specialtyList}
										onChange={(e) => {
											providerPriceCompareStore.setFilterData('specialty', e)

											
											// providerPriceCompareStore.setFilterData(
											// 	'level1Desc',
											// 	null
											// )
											providerPriceCompareStore.setFilterData(
												'procedureName',
												null
											)
											providerPriceCompareStore.setFilterData('modifier', null)
											//providerPriceCompareStore.getProceduresCatList()
											providerPriceCompareStore.getProcedureNameList()
										}}
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
									/> */}
								</div>
							</div>
						</Col>
						<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">
									Group <span className="text-danger">*</span>
								</label>
								<Select
									className={`select-menu ${
										providerPriceCompareStore.selectedFilterData.group !=
										''
											? ''
											: 'invalidFilter'
									}`}
									aria-label="Default select example"
									value={
										providerPriceCompareStore.selectedFilterData.group
									}
									isMulti={false}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData('group', e)

										
										
										
										providerPriceCompareStore.setFilterData('modifier', null)
										providerPriceCompareStore.setFilterData('placeOfService',null)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
										
										providerPriceCompareStore.getPlaceOfServiceList()
										//providerPriceCompareStore.getmodifierList()
										//providerPriceCompareStore.getProcedureNameList()
										providerPriceCompareStore.resetPayerPriceCompList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									options={providerPriceCompareStore.groupList}
								/>
								{/* {providerPriceCompareStore.selectedFilterData.level1Desc == '' && (
									<div className="invalid-input">
										Please select Level 1 Description
									</div>
								)} */}
							</div>
						</Col>
						<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">
								Place Of Service <span className="text-danger">*</span>
								</label>
								<Select
									className={`select-menu ${
										providerPriceCompareStore.selectedFilterData.placeOfService !=
										''
											? ''
											: 'invalidFilter'
									}`}
									aria-label="Default select example"
									value={
										providerPriceCompareStore.selectedFilterData.placeOfService
									}
									isMulti={false}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData('placeOfService', e)
										providerPriceCompareStore.setFilterData('reportingEntityName',null)
										providerPriceCompareStore.setFilterData('billingCode',null)
										providerPriceCompareStore.setFilterData('modifier', null)
									
										providerPriceCompareStore.getBillingCodeList()
										// providerPriceCompareStore.getmodifierList()
										//providerPriceCompareStore.getProcedureNameList()
										providerPriceCompareStore.resetPayerPriceCompList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									options={providerPriceCompareStore.placeOfServiceList}
								/>
								{/* {providerPriceCompareStore.selectedFilterData.level1Desc == '' && (
									<div className="invalid-input">
										Please select Level 1 Description
									</div>
								)} */}
							</div>
						</Col>
						<Col className=" col-auto col-auto">
							<div className="mb-3">
							<label className="form-label">Billing Code<span className='text-danger'>*</span></label>
								<div className="d-flex align-items-center h45 NPI-select">
									<Select
										className={`select-menu`}
										value={providerPriceCompareStore.selectedFilterData.billingCode}
										onChange={(e, data) => {
										
												providerPriceCompareStore.setFilterData('billingCode', e)
												providerPriceCompareStore.setFilterData('reportingEntityName', null)
											providerPriceCompareStore.resetPayerPriceCompList()
										}}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
										options={
											providerPriceCompareStore.billingCodeList?.length
												? providerPriceCompareStore.billingCodeList 
												: []
										}
										allowSelectAll={true}
										
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
										
									/>
									<button
										type="button"
										disabled={
											providerPriceCompareStore.selectedFilterData.billingCode == '' ||
											providerPriceCompareStore.selectedFilterData.billingCode == undefined ||
											providerPriceCompareStore.selectedFilterData.billingCode == null ||
											!providerPriceCompareStore.selectedFilterData.billingCode?.length
										}
										className="NPI-submit btn btn-primary btn-sm"
										onClick={()=>{										
										
											
											// providerPriceCompareStore.setFilterData('procedureName',null)
											
											providerPriceCompareStore.setFilterData('reportingEntityName', null)
										
											providerPriceCompareStore.getReportingEntityNameList()
											providerPriceCompareStore.resetPayerPriceCompList()
										}}
									>
										<FontAwesomeIcon
											icon={faArrowRight}
											className="dropdown-arrow"
											size="lg"
										/>
									</button>
								</div>
							</div>
						</Col>
						<Col className=" col-auto col-auto">
							<div className="mb-3">
								<label className="form-label">Reporting Entity Name<span className='text-danger'>*</span></label>
									<div className="d-flex align-items-center h45 NPI-select">
									<Select
										className={`select-menu`}
										value={providerPriceCompareStore.selectedFilterData.reportingEntityName}
										onChange={(e, data) => {
											
												providerPriceCompareStore.setFilterData('reportingEntityName', e)
												providerPriceCompareStore.setFilterData('modifier', null)
											providerPriceCompareStore.resetPayerPriceCompList()
										}}
										onBlur={() => {
											if(providerPriceCompareStore?.reportingEntityNameList?.length){
												//providersCPTExtractStore.getProceduresCatList()
											}
										}}
										isMulti
										getOptionLabel={(option) => `${option.name}`}
										styles={customStyles}
										options={
											providerPriceCompareStore.reportingEntityNameList.length
												? providerPriceCompareStore.reportingEntityNameList
												: []
										}
										allowSelectAll={true}
										
										closeMenuOnSelect={false}
										hideSelectedOptions={false}
										
									/>
									<button
										type="button"
										disabled={
											providerPriceCompareStore.selectedFilterData.reportingEntityName == '' ||
											providerPriceCompareStore.selectedFilterData.reportingEntityName == undefined ||
											providerPriceCompareStore.selectedFilterData.reportingEntityName == null ||
											!providerPriceCompareStore.selectedFilterData.reportingEntityName?.length
										}
										className="NPI-submit btn btn-primary btn-sm"
										onClick={()=>{										
											// providerPriceCompareStore.setFilterData('procedureName',null)
											providerPriceCompareStore.setFilterData('modifier', null)
											providerPriceCompareStore.getmodifierList()
											providerPriceCompareStore.resetPayerPriceCompList()
										}}
									>
										<FontAwesomeIcon
											icon={faArrowRight}
											className="dropdown-arrow"
											size="lg"
										/>
									</button>
								</div>
							</div>
						</Col>
						
						<Col className=" col-auto" style={ hideProcCategoty ? { display: 'none' } : {}}>
							<div className="mb-3">
								<label className="form-label">
									Procedures Category<span className="text-danger">*</span>
								</label>
								<div
									className={`btn-group d-block procedureCategory ${
										providerPriceCompareStore.selectedFilterData.procedureCat !=
										''
											? ''
											: 'invalidFilter'
									}`}
									role="group"
									aria-label="Basic radio toggle button group"
								>
									{providerPriceCompareStore.proceduresCatList.length ? (
										providerPriceCompareStore.proceduresCatList.map((item) => {
											return (
												<div
													key={`filterdata_${item.name}`}
													onClick={(e) => {
														providerPriceCompareStore.setFilterData(
															'procedureCat',
															item.value
														)
														// providerPriceCompareStore.setFilterData(
														// 	'level1Desc',
														// 	null
														// )
														// providerPriceCompareStore.setFilterData(
														// 	'procedureName',
														// 	null
														// )
														providerPriceCompareStore.setFilterData(
															'modifier',
															null
														)
														providerPriceCompareStore.getBillingCodeList()
														providerPriceCompareStore.resetPayerPriceCompList()
													}}
													className={`btn btn-outline-primary ${
														providerPriceCompareStore.selectedFilterData
															.procedureCat == item.value
															? 'active'
															: ''
													}`}
												>
													<label className="" htmlFor="btnradio1">
														{item.name}
													</label>
												</div>
											)
										})
									) : (
										<span className="nodataFilter">No Data</span>
									)}
								</div>
								{/* {providerPriceCompareStore.selectedFilterData.procedureCat == '' && (
									<div className="invalid-input">
										Please select Procedure Category
									</div>
								)} */}
							</div>
						</Col>
						
						
						
						{/* <Col className=" col-auto col-auto">
							<div className="mb-3 w220">
								<label className="form-label">Payers Count</label>
								<div className="d-flex gap-3 align-items-center h45">
									<Form.Range
										min="0"
										max="12"
										value={
											providerPriceCompareStore.selectedFilterData.payersCount
										}
										onChange={(e, data) => {
											providerPriceCompareStore.selectedFilterData.payersCount =
												e.target.value

												providerPriceCompareStore.setFilterData(
													'procedureName',
													null
												)
												providerPriceCompareStore.setFilterData(
													'modifier',
													null
												)
										}}
										onMouseUp={(e, data) => {
											//zigna_aiStore.getProceduresCatList()
											providerPriceCompareStore.getProcedureNameList()
										}}
									/>
									<span className="range-slider__value">
										{providerPriceCompareStore.selectedFilterData.payersCount}
									</span>
								</div>
							</div>
						</Col> */}
						{/* providerPriceCompareStore.setFilterData(
															'procedureName',
															null
														) */}
						{/*<Col className=" col-auto">
							<div className="mb-3 filterProcedureName">
								<label className="form-label">Procedure Name <span className='text-danger'>*</span></label>
								<Select
									className={`select-menu`}
									aria-label="Default select example"
									value={
										providerPriceCompareStore.selectedFilterData.procedureName
									}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData('procedureName', e)

										providerPriceCompareStore.setFilterData('modifier', null)

										providerPriceCompareStore.getmodifierList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									options={providerPriceCompareStore.procedureNameList}
								/>
								
							</div>
						</Col> */}
						{ !hideModifier ? (<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">Modifiers</label>
								<Select
									className={`select-menu`}
									aria-label="Default select example"
									value={providerPriceCompareStore.selectedFilterData.modifier}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData('modifier', e)
										providerPriceCompareStore.resetPayerPriceCompList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									options={providerPriceCompareStore.modifierList}
								/>
							</div>
						</Col>) : null}
						{/* <Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label"></label>
								<Form>
									<Form.Check
										label="Enhanced"
										id="checkbox1"
										htmlFor="checkbox1"
										checked={
											providerPriceCompareStore.selectedFilterData.enhanced
										}
										onChange={(e) => {
											providerPriceCompareStore.setFilterData(
												'enhanced',
												!providerPriceCompareStore.selectedFilterData.enhanced
											)
										}}
									/>
								</Form>
							</div>
						</Col>
						<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label"></label>
								<Form>
									<Form.Check
										label="Community"
										id="checkbox2"
										htmlFor="checkbox2"
										checked={
											providerPriceCompareStore.selectedFilterData.community
										}
										onChange={(e) => {
											providerPriceCompareStore.setFilterData(
												'community',
												!providerPriceCompareStore.selectedFilterData.community
											)
										}}
									/>
								</Form>
							</div>
						</Col> */}
						<div className="col-auto sep_filter">
							<span className="sepText"></span>
						</div>
						{ showAggMeasure && (<Col className=" col-auto">
							<div className="mb-3">
								<label className="form-label">
									Aggregation Measure
								</label>
								<Select
									className={`select-menu`}
									aria-label="Default select example"
									value={
										providerPriceCompareStore.selectedFilterData
											.aggregationMeasure
									}
									isMulti={false}
									onChange={(e) => {
										providerPriceCompareStore.setFilterData(
											'aggregationMeasure',
											e
										)
										providerPriceCompareStore.resetPayerPriceCompList()
									}}
									getOptionLabel={(option) => `${option.name}`}
									styles={customStyles}
									options={providerPriceCompareStore.aggregationMeasureList}
								/>
								{/* {providerPriceCompareStore.selectedFilterData.procedureName == '' && (
									<div className="invalid-input">Please select Procedure</div>
								)} */}
							</div>
						</Col>)}
						<Col className=" col-auto">
							<label className="form-label">{'   '}</label>
							<div className="d-flex align-item-center">
								<Button
									variant="primary"
									size="sm"
									className="submitFilter"
									onClick={(e) => {
										providerPriceCompareStore.resetPayerPriceCompList()
										actionFunc()
									}}
									type="button"
								>
									Submit
								</Button>
							</div>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		)
	})
)
